<script>
    import { shipmentStore } from "../../stores/store.js";
    export let displayList = [];
    export let handleMasterClick;
    export let resetToMain;
    export let handleListScroll;
    export let scrollContainer; // bindable
</script>

<section
    class="pane master-box"
    class:collapsed={$shipmentStore.selectedItem !== null}
>
    <div class="pane-header">
        <h2>
            {$shipmentStore.selectedItem
                ? "📌 선택된 수주정보"
                : "📦 수주정보 리스트"}
            <span class="total-badge">
                총 {$shipmentStore.list.length}건
            </span>
        </h2>
        {#if $shipmentStore.selectedItem}<button
                class="back-link"
                on:click={resetToMain}
            >
                목록 전체보기 ↩
            </button>{/if}
    </div>
    <div
        class="table-scroll"
        bind:this={scrollContainer}
        on:scroll={handleListScroll}
    >
        <table class="mes-table">
            <thead>
                <tr>
                    <th>No.</th>
                    <th>납품처코드</th>
                    <th>거래처명</th>
                    <th>출하형태</th>
                    <th>출하형태명</th>
                    <th>수주형태코드</th>
                    <th>수주형태명</th>
                    <th>공장코드</th>
                    <th>공장명</th>
                    <th>출하요청</th>
                </tr>
            </thead>
            <tbody>
                {#each $shipmentStore.selectedItem ? [$shipmentStore.selectedItem] : displayList as item, i}
                    <tr
                        class:selected-row={$shipmentStore.selectedItem}
                        on:click={() =>
                            !$shipmentStore.selectedItem &&
                            handleMasterClick(item)}
                    >
                        <td class="center">{i + 1}</td>
                        <td>{item.shipmnt_bcnc_code || ""}</td>
                        <td class="bold">{item.bcnc_nm || ""}</td>
                        <td>{item.shipmnt_ty_code || ""}</td>
                        <td>{item.shipmnt_ty_nm || ""}</td>
                        <td>{item.rcvord_ty_code || ""}</td>
                        <td>{item.rcvord_ty_nm || ""}</td>
                        <td>{item.fctry_code || ""}</td>
                        <td>{item.fctry_nm || ""}</td>
                        <td class="center status-col">
                            {item.shipmnt_requst_at || ""}
                        </td>
                    </tr>
                {/each}
            </tbody>
        </table>
    </div>
</section>

<style>
    .pane {
        background: white;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        overflow: hidden;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    }
    .pane-header {
        padding: 0 12px;
        background: #f8fafc;
        border-bottom: 1px solid #f1f5f9;
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 42px;
        flex-shrink: 0;
    }
    .pane-header h2 {
        font-size: 0.8rem;
        margin: 0;
        font-weight: 800;
        color: #475569;
        display: flex;
        align-items: center;
        gap: 8px;
    }
    .master-box {
        transition: all 0.3s ease;
        flex: 1;
        min-height: 200px;
    }
    .master-box.collapsed {
        flex: none !important;
        height: 130px !important;
        min-height: 130px !important;
        border: 2px solid #3b82f6;
    }
    .master-box.collapsed .table-scroll {
        overflow-y: hidden !important;
    }
    .back-link {
        background: #ffffff;
        color: #3b82f6;
        border: 1.5px solid #bfdbfe;
        padding: 6px 16px;
        border-radius: 20px;
        font-weight: 800;
        font-size: 0.75rem;
        cursor: pointer;
        transition: all 0.2s ease;
        display: flex;
        align-items: center;
    }
    .back-link:hover {
        background: #eff6ff;
        border-color: #3b82f6;
        transform: translateY(-1px);
    }
    .table-scroll {
        flex: 1;
        overflow: auto;
        border-radius: 0 0 10px 10px;
    }
    .mes-table {
        width: 100%;
        border-collapse: collapse;
        table-layout: auto;
        min-width: max-content;
    }
    .mes-table th {
        position: sticky;
        top: 0;
        background: #f8fafc;
        padding: 10px 12px;
        font-size: 0.75rem;
        color: #64748b;
        border-bottom: 2px solid #e2e8f0;
        z-index: 5;
        text-align: left;
        white-space: nowrap;
    }
    .mes-table td {
        padding: 10px 12px;
        border-bottom: 1px solid #f1f5f9;
        font-size: 0.9rem;
        cursor: pointer;
        white-space: nowrap;
    }
    .selected-row td {
        background: #eff6ff !important;
        color: #1e3a8a;
        font-weight: 600;
    }
    .center {
        text-align: center;
    }
    .bold {
        font-weight: 700;
    }
</style>
